import React from 'react';

export function NavigationIcon({ size = 16, color = 'currentColor', style, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color, ...style }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4584 1.54327C14.0466 1.13148 13.5048 1.18266 13.1254 1.26787C12.7412 1.35417 12.2557 1.53916 11.6992 1.75122L11.6511 1.76952L1.38732 5.67955C0.954197 5.84455 0.667969 6.25988 0.667969 6.72337C0.667969 7.20416 0.975623 7.631 1.43174 7.78304L3.67583 8.53107C5.29108 9.06949 5.88032 9.28333 6.29931 9.70232C6.7183 10.1213 6.93214 10.7105 7.47056 12.3258L8.21859 14.5699C8.37063 15.026 8.79747 15.3337 9.27826 15.3337C9.74174 15.3337 10.1571 15.0474 10.3221 14.6143L14.2321 4.35049L14.2504 4.30247L14.2504 4.30244C14.4625 3.74592 14.6475 3.26042 14.7338 2.87619C14.819 2.49679 14.8701 1.95506 14.4584 1.54327Z"
        fill="currentColor"
      />
    </svg>
  );
}
